import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Point} from 'pixi.js';

// Constructor
export class GameH_Dropzone extends PIXI.Container {

  constructor(data, game) {
    super();

    this.game = game;
    this.data = data;

    this.id = this.data.id;
    this.isFilled = false;

    this.markerSize = 48;
    this.markerPosition = {
      "glasses": {
        "x": this.data.width - 5,
        "y": (this.data.height / 2) - (this.markerSize / 2) - 20
      },
      "coat": {
        "x": this.data.width - 12,
        "y": (this.data.height / 2) - (this.markerSize / 2) + 42
      },
      "boots": {
        "x": this.data.width - 21,
        "y": (this.data.height / 2) - (this.markerSize / 2) + 47
      },
    }

    this.position.set(this.data.x, this.data.y);
    this.originalPosition = new PIXI.Point().copyFrom(this.position); // copy original position to a variable for later

    this.build();
    this.enable();
  }

  build() {
    // add a background so we have an actual size
    this.background = new PIXI.Graphics().rect(0, 0, this.data.width, this.data.height).fill(0x000000);
    this.background.alpha = 0;
    this.addChild(this.background);

    // Good/Bad marker
    let markerPosition = {
      x: this.markerPosition[this.id].x ?? this.background.width,
      y: this.markerPosition[this.id].y ?? (this.background.height / 2) - (this.markerSize / 2)
    };
    this.goodAnswerIcon = new PIXI.Sprite(this.game.assets["good-answer"]);
    this.goodAnswerIcon.width = this.markerSize;
    this.goodAnswerIcon.height = this.markerSize;
    this.goodAnswerIcon.position.x = markerPosition.x;
    this.goodAnswerIcon.position.y = markerPosition.y;
    this.goodAnswerIcon.alpha = 0.0;
    this.addChild(this.goodAnswerIcon);

    this.badAnswerIcon = new PIXI.Sprite(this.game.assets["bad-answer"]);
    this.badAnswerIcon.width = this.markerSize;
    this.badAnswerIcon.height = this.markerSize;
    this.badAnswerIcon.position.x = markerPosition.x;
    this.badAnswerIcon.position.y = markerPosition.y;
    this.badAnswerIcon.alpha = 0.0;
    this.addChild(this.badAnswerIcon);

    // this.buildAnimations();
  }

  enable() {
    this.eventMode = "static";
  }

  showAnswerMarker(state = true) {
    let showMarker = state ? this.goodAnswerIcon : this.badAnswerIcon;
    let hideMarker = state ? this.badAnswerIcon : this.goodAnswerIcon ;
    gsap.to(hideMarker, {
      pixi: {
        alpha: 0.0
      },
      duration: 0.25,
      ease: "power1.inOut",
    });
    gsap.to(showMarker, {
      pixi: {
        alpha: 1.0,
      },
      duration: 0.25,
      ease: "power1.inOut",
    });
  }

  hideAnswerMarker() {
    gsap.to([this.goodAnswerIcon, this.badAnswerIcon], {
      pixi: {
        alpha: 0.0,
      },
      duration: 0.25,
      ease: "power1.inOut",
    });
  }

  getBoundingBox() {
    let dropZoneGlobalPos = this.toGlobal(new PIXI.Point(0, 0));

    return {
      x: dropZoneGlobalPos.x,
      y: dropZoneGlobalPos.y,
      width: this.width,
      height: this.height,
      top: dropZoneGlobalPos.y,
      right: dropZoneGlobalPos.x + this.width,
      bottom: dropZoneGlobalPos.y + this.height,
      left: dropZoneGlobalPos.x
    };
  }

  resetState(duration) {
    this.isFilled = false;

    // this.animateReset(duration);
  }

  // Reset the states so we can animate in again and start over
  reset() {
    // if (this.inAnimation) {
    //   this.inAnimation.kill();
    //   this.inAnimation = null;
    // }

    this.resetState(0);

    // Rebuild the animations
    // this.buildAnimations();
  }

  // buildAnimations() {
  //   this.inAnimation = gsap.fromTo(this, {
  //       pixi: {
  //         y: this.originalPosition.y + 40,
  //         alpha: 0,
  //       },
  //     }, {
  //       pixi: {
  //         y: this.originalPosition.y,
  //         alpha: 1,
  //       },
  //       ease: "quad.out",
  //       immediateRender: true,
  //       paused: true,
  //       duration: 1,
  //       onComplete: () => {
  //         this.enable();
  //       }
  //     }
  //   )
  //
  // }

  // animateIn() {
  //   if (this.inAnimation) {
  //     this.inAnimation.play();
  //   }
  // }

  // animateDropped() {
  //   gsap.killTweensOf(this);
  //
  //   gsap.to(this, {
  //       pixi: {
  //         alpha: 0,
  //       },
  //       ease: "quad.out",
  //       duration: 0.25,
  //     }
  //   );
  // }

  // animateReset(duration = 0.25) {
  //   gsap.killTweensOf(this);
  //
  //   gsap.to(this, {
  //       pixi: {
  //         alpha: 1,
  //       },
  //       ease: "quad.out",
  //       duration: duration,
  //     }
  //   );
  // }
}
